import Filters, { registerModuleFilters } from '@/utils/input/filters';
import { createEnumOptions } from '@/utils/core/data-transformation';
import { getEnumNamespace } from '@/utils/infrastructure';
import { CoreEnums } from '@/utils/domain/constants';
import { connectionTypeIcons } from './constants';

const TypeFilter = {
  ...Filters.BaseFilters.EnumFilter,
  name: 'type',
  label: 'global.type',
  enumNamespace: getEnumNamespace(CoreEnums.ConnectionType, 'Connections'),
  enumSource: CoreEnums.ConnectionType,
  options: createEnumOptions(CoreEnums.ConnectionType, 'connections.type'),
  iconMap: connectionTypeIcons,
  allowSearch: true,
  showSearch: true,
};

const GroupFilter = {
  ...Filters.BaseFilters.RemoteFilter,
  name: 'groupId',
  label: 'global.text.group',
  apiRoute: 'connectionGroup/paged',
  params: { select: 'id,name', orderBy: 'name asc' },
};

const ServerFilter = {
  ...Filters.BaseFilters.RemoteFilter,
  name: 'serverId',
  label: 'connections.text.server',
  apiRoute: 'server/paged',
  params: { select: 'id,name', orderBy: 'name asc' },
};

const OwnerFilter = {
  ...Filters.BaseFilters.RemoteFilter,
  name: 'ownerUserId',
  label: 'connections.text.ownerUser',
  apiRoute: 'user/paged',
  params: { select: 'id,fullName', orderBy: 'fullName asc' },
};

const IsPublicFilter = {
  ...Filters.BaseFilters.BooleanFilter,
  name: 'isPublic',
  label: 'global.text.isPublic',
};

const ValidatedFilter = {
  ...Filters.BaseFilters.BooleanFilter,
  name: 'validated',
  label: 'global.text.validated',
};

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
};

const UpdatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.updatedDate',
  name: 'updatedDateRange',
};

export const filtersConfig = [
  TypeFilter,
  GroupFilter,
  ServerFilter,
  OwnerFilter,
  IsPublicFilter,
  ValidatedFilter,
  Filters.IsActiveFilter,
  CreatedDateFilter,
  UpdatedDateFilter,
];

registerModuleFilters('connections', [TypeFilter]);
